import { Badge, BadgeSize } from '@soteria/design-system-ve';

import * as styles from './PolicyDisplay.css';

interface PolicyOverallStatusProps {
  isCompliant: boolean;
  totalPoliciesEvaluated: number;
  allowedCount: number;
  rejectedCount: number;
}

/**
 * Displays the overall policy evaluation status with violation count
 */
export function PolicyOverallStatus({ isCompliant, totalPoliciesEvaluated, allowedCount, rejectedCount }: PolicyOverallStatusProps) {
  return (
    <div className={styles.overallStatus}>
      <Badge size={BadgeSize.Small} text={isCompliant ? 'ALLOWED' : 'REJECTED'} />
      {totalPoliciesEvaluated > 0 && (
        <span className={styles.policyCount} title={`${allowedCount} allowed, ${rejectedCount} rejected out of ${totalPoliciesEvaluated} policies`}>
          ({rejectedCount}/{totalPoliciesEvaluated}) Violations
        </span>
      )}
    </div>
  );
}
